<template>
  <div class="attshiftcont">
    <div style="display: flex">
      <Headbuttom></Headbuttom>
      <Tabheader
        @handRegister="handRegister"
        @handFromshow="handFromshow"
        :titlename="titlename"
      ></Tabheader>
    </div>

    <div class="attheadfrom" v-show="flag">
      <el-form
        :inline="true"
        size="small"
        :model="searchParams"
        class="demo-form-inline"
      >
        <el-form-item label="公司名称">
          <el-input
            v-model="searchParams.name"
            placeholder="公司名称"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item :label="$t('devtable.sjhm')">
          <el-input
            v-model="searchParams.mobile"
            :placeholder="$t('devtable.sjhm')"
          ></el-input>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="onSubmit">{{
            $t("devtable.cx")
          }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <Userdialog
      @userhandleClose="userhandleClose"
      :userdialog="userdialog"
      @userdialogVisibletrue="userdialogVisibletrue"
    >
      <el-form :model="delform">
		  <el-form-item label="公司名称" :label-width="formLabelWidth">
		    <el-input
		      v-model="delform.user_name"
		      autocomplete="off"
		  	style="width: 120px;"
			disabled
		    ></el-input>
		  </el-form-item>
        <el-form-item label="折扣" :label-width="formLabelWidth">
          <el-input
            v-model="delform.user_name_input"
            autocomplete="off"
			style="width: 120px;"
          ></el-input>
		  折
        </el-form-item>
        <!-- <el-form-item :label="$t('devtable.mm')" :label-width="formLabelWidth">
          <el-input
            v-model="delform.user_pass_input"
            autocomplete="off"
          ></el-input>
        </el-form-item> -->
      </el-form>
    </Userdialog>
    <Tables
      @handlerow="handlerow"
      @handlpages="handlpages"
      @handleSizeChange="handleSizeChange"
      :tableLabel="tableLabel"
      :tableData="tableData"
      :flags="flags"
      :configs="configs"
      :operation="operation"
    ></Tables>
		<!-- 修改 -->
    <Attshitdilg
      @addManagerSuccess="addManagerSuccess"
      ref="attshitdilg"
    ></Attshitdilg>
		<!-- 添加 -->
    <Adttshitdilg
      @addManagerSuccess="addManagerSuccess"
      ref="adttshitdilg"
    ></Adttshitdilg>
  </div>
</template>
<script>
import Tables from "@/components/table";
import Tabheader from "@/views/workattendance/components/tabheader";
import Attshitdilg from "./components/index";
import Adttshitdilg from "./components/addindex";
import Userdialog from "@/components/dialog/userfrom";

import methodlist from "../../utils/methods.js";
export default {
  components: {
    Tables,
    Tabheader,
    Attshitdilg,
    Userdialog,
    Adttshitdilg,
  },
  data() {
    return {
      flag: false,
      formLabelWidth: "80px",
      value1: "",
      searchParams: {
        name: "",
        mobile: "",
      },
      titlename: {
        name: this.$t("navLeft.addU"),
        placeholdername: "请点击查询",
      },
      userdialog: {
        dialogVisible: false,
        title: '设置折扣',
      },
      delform: {
		  user_name:'',
        user_name_input: "",
      },
      delData: "",

      tableData: [],
      flags: {
        show: false, // 多选是否显示
        ishow: false, // 序号是否显示
      },
      // 分页数据
      configs: {
          page_index:1,
        pagesize: 10,
        total: 200,
        loading: false, // 加载状态
      },

      UserInfo: "",
	  agentId:''
    };
  },
  computed: {
    operation: function () {
      return {
        width: "200px",
        data: [
          {
            name: '设置折扣',
            type: "primary",
          },
        ],
      };
    },
    tableLabel: function () {
      return [
        {
          prop: "id",
          label: 'id',
          align: "center",
			width:120
        },
        {
          prop: "name",
          label: '公司名称',
          align: "center",
        },
        {
          prop: "discount",
          label: '折扣',
          align: "center",
        },
      ];
    },
  },
  mounted() {
    this.UserInfo = JSON.parse(window.localStorage.getItem("user"));
    this.getAdminstrorList(1);
  },
  methods: {
    handlerow(v, name) {
      console.log("handlerow", v);
      // return false
	  this.userdialog.dialogVisible = true;
      this.agentId = v.id
	  let data = {
		  method:'co.agent.discount.get',
		  id:this.agentId
	  }
	  this.$serve(data).then((res) => {
	    console.log(res);
	    if (res.data.code == 0) {
			this.delform.user_name_input = res.data.data.discount*10
			this.delform.user_name = res.data.data.name
		}
	  });
    },
    //关闭删除框
    userhandleClose() {
      console.log("userhandleClose");
      this.userdialog.dialogVisible = false;
    },

    //删除弹窗: 确定删除管理员
    userdialogVisibletrue() {
      console.log("userdialogVisibletrue");

      if (this.delform.user_name_input =='') {
        this.$message({
          type: "warning",
          message: '请设置折扣',
        });
        return false;
      }

      const params = {
        method: 'co.agent.discount.update',
        agent_id: this.agentId,
        discount: this.delform.user_name_input/10,
      };
      this.$serve(params).then((res) => {
        console.log(res);
        if (res.data.code == 0) {
          this.$message({
            message: '折扣设置成功',
            type: "success",
          });
          this.userdialog.dialogVisible = false;
          this.getAdminstrorList(1);
        } else {
          //删除失败
          
            this.$message({
              message: '设置失败',
              type: "warning",
            });
          
        }
      });
    },
    onSubmit() {
      console.log("submit!");
      this.getAdminstrorList(1);
    },
    handRegister() {
      if (this.UserInfo.is_sys_admin == "0") {
        this.$message({
          message: this.$t("devtable.gglymqxtj"),
          type: "warning",
        });
        return;
      }

      this.$refs.adttshitdilg.dialogFormVisible = true;
    },
    handFromshow() {
      this.flag = !this.flag;
    },
    handlpages(v) {
      this.configs.page_index = v;
      this.getAdminstrorList();
    },
    handleSizeChange(v) {
      this.configs.page_index = 1;
      this.configs.pagesize = v;
      this.getAdminstrorList();
    },

    getAdminstrorList(pageIndex) {
      const params = {
        method: 'co.agent.discount.list',
        page_index: pageIndex?pageIndex:this.configs.page_index,
        page_size: this.configs.pagesize,
        name: this.searchParams.name,
      };
      this.$serve(params).then((res) => {
        console.log(res);
        this.tableData = res.data.data;
        this.configs.total = res.data.count;
        this.tableData.forEach((el) => {
          if (el.type == 1) {
            el.type_hint = {
              name: this.$t("devtable.rsjl"),
              state: true,
              type: "primary",
            };
          } else {
            el.type_hint = {
              name: this.$t("devtable.czy"),
              state: true,
              type: "primary",
            };
          }

          el.password = "******";

          el.menu_hint = {
            name: this.getMenuShowHint(el.menu),
            state: true,
            type: "primary",
          };
        });
      });
    },
    addManagerSuccess() {
      this.getAdminstrorList(1);
    },
    getMenuShowHint(menu) {
      let menu_01 = ["1", "2"];
      let menu_02 = ["3", "4"];
      let menu_03 = ["5", "6", "7", "8"];
      let menu_04 = ["9", "10"];
      let menu_05 = ["11", "12", "13", "14", "15", "16", "17", "18"];
      let menu_06 = ["19", "20", "21", "22", "23", "24"];
      let menu_07 = ["25", "26"];
      let menuStr = [];
      let flag = 0;

      flag = 0;
      menu_01.forEach((item) => {
        if (menu.indexOf(item) != -1) {
          flag = 1;
        }
      });
      if (flag == 1) {
        menuStr.push(this.$t("navLeft.qygl"));
      }

      flag = 0;
      menu_02.forEach((item) => {
        if (menu.indexOf(item) != -1) {
          flag = 1;
        }
      });
      if (flag == 1) {
        menuStr.push(this.$t("navLeft.sbgl"));
      }

      flag = 0;
      menu_03.forEach((item) => {
        if (menu.indexOf(item) != -1) {
          flag = 1;
        }
      });
      if (flag == 1) {
        menuStr.push(this.$t("navLeft.ygglH"));
      }

      flag = 0;
      menu_04.forEach((item) => {
        if (menu.indexOf(item) != -1) {
          flag = 1;
        }
      });
      if (flag == 1) {
        menuStr.push(this.$t("navLeft.fkgl"));
      }

      flag = 0;
      menu_05.forEach((item) => {
        if (menu.indexOf(item) != -1) {
          flag = 1;
        }
      });
      if (flag == 1) {
        menuStr.push(this.$t("navLeft.kqgl"));
      }

      flag = 0;
      menu_06.forEach((item) => {
        if (menu.indexOf(item) != -1) {
          flag = 1;
        }
      });
      if (flag == 1) {
        menuStr.push(this.$t("navLeft.bbsj"));
      }

      flag = 0;
      menu_07.forEach((item) => {
        if (menu.indexOf(item) != -1) {
          flag = 1;
        }
      });
      if (flag == 1) {
        menuStr.push(this.$t("navLeft.xtsz"));
      }

      return menuStr.join(",");
    },
  },
};
</script>
<style lang="less" scoped>
.attshiftcont {
  padding: 20px;
  background-color: #fff;
  .attheadfrom {
    padding: 20px;
    margin-top: 10px;
  }
}
</style>